import React from 'react';
import type { EinweisungPublic } from '../../sige-plan/types';
import { formatDatum } from './einweisungTeilnahmeLogic';
import { KNOPF_PRIMAER } from '../../sifa/public/teilnahmeSeiteStil';

/** Erste Karte: welches Bauvorhaben, welche Einweisung, wer sie durchfuehrt. */
export const EinweisungBegruessung: React.FC<{
  einweisung: EinweisungPublic;
  onLesen: () => void;
}> = ({ einweisung, onLesen }) => {
  const planZeile = [einweisung.planNr ? `Plan-Nr. ${einweisung.planNr}` : '', einweisung.planStand ? `Stand ${formatDatum(einweisung.planStand)}` : '']
    .filter(Boolean)
    .join(' · ');
  const datum = [formatDatum(einweisung.datum), einweisung.uhrzeit ? `${einweisung.uhrzeit} Uhr` : ''].filter(Boolean).join(', ');

  return (
    <div className="space-y-5">
      <div className="space-y-1">
        {einweisung.bueroName && <p className="text-sm font-medium text-slate-500">{einweisung.bueroName}</p>}
        <h1 className="text-2xl font-bold text-slate-900">Einweisung in den SiGe-Plan Nr. {einweisung.nummer}</h1>
        {einweisung.titel && <p className="text-slate-700">{einweisung.titel}</p>}
      </div>

      {(einweisung.projektName || einweisung.bauvorhabenAdresse) && (
        <div className="p-3 bg-slate-50 rounded-xl space-y-0.5">
          <p className="text-sm text-slate-500">Bauvorhaben</p>
          {einweisung.projektName && <p className="font-semibold text-slate-900">{einweisung.projektName}</p>}
          {einweisung.bauvorhabenAdresse && <p className="text-slate-700 whitespace-pre-line">{einweisung.bauvorhabenAdresse}</p>}
        </div>
      )}

      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-base">
        {planZeile && (
          <div className="p-3 bg-slate-50 rounded-xl">
            <dt className="text-sm text-slate-500">SiGe-Plan</dt>
            <dd className="font-semibold">{planZeile}</dd>
          </div>
        )}
        {einweisung.durchfuehrenderName && (
          <div className="p-3 bg-slate-50 rounded-xl">
            <dt className="text-sm text-slate-500">Durchgeführt von</dt>
            <dd className="font-semibold">{einweisung.durchfuehrenderName}</dd>
          </div>
        )}
        {datum && (
          <div className="p-3 bg-slate-50 rounded-xl">
            <dt className="text-sm text-slate-500">Datum der Einweisung</dt>
            <dd className="font-semibold">{datum}</dd>
          </div>
        )}
        {einweisung.ort && (
          <div className="p-3 bg-slate-50 rounded-xl">
            <dt className="text-sm text-slate-500">Ort</dt>
            <dd className="font-semibold">{einweisung.ort}</dd>
          </div>
        )}
      </dl>

      <p className="text-slate-600">
        Du liest die Stichpunkte der Einweisung, trägst danach deinen Namen und deine Firma ein und bestätigst mit
        deiner Unterschrift. Das dauert nur wenige Minuten.
      </p>

      <button type="button" onClick={onLesen} className={KNOPF_PRIMAER}>
        Einweisung lesen
      </button>
    </div>
  );
};
